export const MAX_BYTES = 5000000;
export const MAX_BYTES_10 = 10000000;
export const MAX_BYTES_8 = 8000000;